// extracted by mini-css-extract-plugin
module.exports = {"amenitiesBtn":"AmenitiesBtn-module--amenitiesBtn--3geKN","delimiter":"AmenitiesBtn-module--delimiter--18jpU"};